import { Image } from '@packages/shared/src/ui/Image/Image';

type IconProps = {
  src: string;
  size?: number;
};

/**
 * atom for Aplus - renders an icon based on the provided source path and size
 */
export const Icon = ({ src, size = 32 }: IconProps) => (
  <Image
    src={`${src}.svg`}
    alt=""
    width={size}
    height={size}
    unoptimized
    className="block max-w-fit"
  />
);
